import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ApprovalsMainComponent } from '@app/components/sections/approvals/main/main.component';

export const approvalsRoutes: Routes = [
    {
        path: 'approvals',
        component: ApprovalsMainComponent,
    },
    {
        path: 'approvals/:status',
        component: ApprovalsMainComponent,
    }
]

@NgModule({
    imports: [
        RouterModule.forRoot(approvalsRoutes)
    ],
    exports: [RouterModule]
})
export class AppApprovalsRouterModule { }